(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-featured-products').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];

			new Swiper(sliderEl, {
				direction: 'horizontal',
				navigation: {
					nextEl: $('.js-carousel-nav-next', sliderContainer)[0],
					prevEl: $('.js-carousel-nav-prev', sliderContainer)[0],
				},
				slidesPerView: 1,
				spaceBetween: 20,
				breakpoints: {
					744: {
						slidesPerView: 2,
						spaceBetween: 28,
					},
					1024: {
						slidesPerView: 3,
						spaceBetween: 40,
					}
				}
			});
		});
	});
})(jQuery, document, window);
